export function StatusBadge({ status, className = '' }: { status: string; className?: string }) {
  const normalizedStatus = status.toLowerCase();
  
  const colors: Record<string, string> = {
    draft: 'bg-gray-100 text-gray-800 border-gray-200',
    published: 'bg-green-100 text-green-800 border-green-200',
    superseded: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    archived: 'bg-red-100 text-red-800 border-red-200',
    active: 'bg-green-100 text-green-800 border-green-200',
    inactive: 'bg-gray-100 text-gray-800 border-gray-200',
  };

  const colorClass = colors[normalizedStatus] || 'bg-gray-100 text-gray-800 border-gray-200';

  const formatText = (text: string) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
  };

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${colorClass} ${className}`}
    >
      {formatText(status)}
    </span>
  );
}
